import { situacaoAplicacaoEnum } from '@/enum/situacaoAplicacao'

const ID_DOSE_UNICA = 1

export default {
  methods: {
    temMultiplasDoses(item) {
      return item.id_dose !== ID_DOSE_UNICA && item.id_dose !== null
    },

    podeVacinar(item) {
      if (!item.vacinado || item.aplicacao?.situacao === situacaoAplicacaoEnum.ESTORNADA) {
        return true
      }

      if (this.temMultiplasDoses(item)) {
        return true
      }

      return this.vacinasCampanha?.length > 1
    },

    formatDescricaoVacinaDose(item) {
      const nomeVacina = item.nome_vacina || item.nome_tecnico

      return nomeVacina
        ? `${nomeVacina} - ${item.descricao_dose}`
        : item.descricao_dose
    },
  },
}
